import {DomElementChildInserter} from "@ok/common/utils/dom/DomElementChildInserter";
import {NumberGenerator} from "@ok/common/utils/numbers/NumberGenerator";
import {numberIntervalsToRandomIntGenerators} from "@ok/common/utils/numbers/parseIntervals";
import {AppController} from "@ok/web/modules/block/AppController";
import {type IItemsAddedEventData, itemsAddedEventType} from "OK/ajaxList/autoLoadEvent";
import {FeedBannerHook} from "OK/ads/banner/hook/FeedBannerHook";

import {RbAdBannerFeedListStore} from "./RbAdBannerFeedListStore";

export class RbAdBannerFeedListController extends AppController<RbAdBannerFeedListStore> {
    private adBannerInserter: DomElementChildInserter<HTMLElement> | undefined;
    private bannerHookList: FeedBannerHook[] = [];
    private feedListElement: Element | null | undefined;

    createAdBannerBox = () => {
        const { settings } = this.store;
        const bannerBox = window.document.createElement(settings.boxTag || 'div');
        if (settings.boxCssClass) {
            bannerBox.className = settings.boxCssClass;
        }
        return bannerBox;
    };

    private insertAdBanners() {
        const { adBannerInserter } = this;
        if (!adBannerInserter) {
            return;
        }
        const { settings } = this.store;
        const bannerBoxes = adBannerInserter.insert();
        for (let i = 0, len = bannerBoxes.length; i < len; i++) {
            const bannerHook = new FeedBannerHook({
                bannerName: settings.bannerName || 'Feed',
                bannerParams: settings,
                element: bannerBoxes[i]
            });
            bannerHook.activate();
            this.bannerHookList.push(bannerHook);
        }
    }

    private handleFeedsAdded = (event: Event) => {
        const eventData = (event as CustomEvent).detail as IItemsAddedEventData;
        if (eventData && eventData.container === this.feedListElement) {
            this.insertAdBanners();
        }
    };

    start() {
        const { settings } = this.store;
        if (!settings.feedListSelector || !settings.listInserterSkipRanges) {
            return;
        }
        const parentElement = this.domFacade.getNode()?.parentElement;
        if (parentElement) {
            this.feedListElement = parentElement.querySelector(settings.feedListSelector);
        }
        if (!this.feedListElement) {
            this.feedListElement = window.document.querySelector(settings.feedListSelector);
        }
        if (!this.feedListElement) {
            return;
        }

        const skipGenerator = new NumberGenerator({
            getters: numberIntervalsToRandomIntGenerators({
                intervals: settings.listInserterSkipRanges,
                itemDelimiter: ',',
                minMaxDelimiter: '-'
            })
        });
        this.adBannerInserter = new DomElementChildInserter({
            getNewChild: this.createAdBannerBox,
            getSkippedCount: skipGenerator,
            target: this.feedListElement
        });

        this.insertAdBanners();

        window.document.addEventListener(itemsAddedEventType, this.handleFeedsAdded);
    }

    end() {
        const { adBannerInserter, bannerHookList } = this;
        if (adBannerInserter) {
            for (let i = 0, len = bannerHookList.length; i < len; i++) {
                bannerHookList[i].deactivate();
            }
            adBannerInserter.dispose();
            window.document.removeEventListener(itemsAddedEventType, this.handleFeedsAdded);
        }
    }
}
